"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, prefetch, useQuery } from "@opensea/graphql";
import { useState } from "react";
import { TraitOffersFilterTableRowFragment } from "@/components/filters-side-panel/TraitOffersFilterSection/TraitOffersFilterTableRow.fragment";
import { OfferAggregateTotalsFragment } from "@/components/offers/collection/OfferAggregateTotals.fragment";
import { useTraitOfferAggregatesTotalSubscription } from "./use-trait-offer-aggregates-total-subscription";
export const traitOfferAggregatesTotalQuery = graphql(`
    query useTraitOfferAggregatesTotalQuery(
      $collectionSlug: String!
      $filter: TraitOffersFilter
    ) {
      traitOfferAggregatesTotal(
        collectionSlug: $collectionSlug
        filter: $filter
      ) {
        id
        traitType
        traitValue
        bestOfferPrice {
          usd
        }
        maxValueInTick {
          usd
        }
        totalOffers
        ...OfferAggregateTotals
        ...TraitOffersFilterTableRow
      }
    }
  `, [OfferAggregateTotalsFragment, TraitOffersFilterTableRowFragment]);
export function useTraitOfferAggregatesTotal(t0) {
  const $ = _c(7);
  const {
    collectionSlug,
    filter
  } = t0;
  let t1;
  if ($[0] !== collectionSlug || $[1] !== filter) {
    t1 = {
      query: traitOfferAggregatesTotalQuery,
      variables: {
        collectionSlug,
        filter
      }
    };
    $[0] = collectionSlug;
    $[1] = filter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [t2] = useQuery(t1);
  const {
    data
  } = t2;
  let t3;
  if ($[3] !== data?.traitOfferAggregatesTotal) {
    t3 = data?.traitOfferAggregatesTotal ?? [];
    $[3] = data?.traitOfferAggregatesTotal;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [traitOfferAggregatesTotal, setTraitOfferAggregatesTotal] = useState(t3);
  let t4;
  if ($[5] !== collectionSlug) {
    t4 = {
      variables: {
        collectionSlug
      },
      setItems: setTraitOfferAggregatesTotal
    };
    $[5] = collectionSlug;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useTraitOfferAggregatesTotalSubscription(t4);
  return traitOfferAggregatesTotal;
}
export const prefetchUseTraitOfferAggregatesTotal = (collectionSlug, client) => {
  prefetch(client, traitOfferAggregatesTotalQuery, {
    collectionSlug
  });
};